// extracted by mini-css-extract-plugin
export var ratingRowMobileContainer = "rating-row-mobile-container____qb";
export var row = "row__S5bC";
export var selected = "selected__k1Wy";